<template>
  <div>
    <div class="app-os">iOS</div>
    <div class="app-image">
      <p class="app-image__p">{{ Link.runkeeperMap[lang] }}</p>
      <img
        :src="`https://tmf-virtualrun.jp/images/oauth/${lang}/runkeeper-ios-app-map.png`"
        width="270"
        alt=""
        class="img"
      />
      <p class="app-image__p">{{ Link.runkeeperMenu[lang] }}</p>
      <img
        :src="`https://tmf-virtualrun.jp/images/oauth/${lang}/runkeeper-ios-app-menu.png`"
        width="270"
        alt=""
        class="img"
      />
    </div>
    <div class="app-os">Android</div>
    <div class="app-image">
      <p class="app-image__p">{{ Link.runkeeperMapAndroid[lang] }}</p>
      <img
        :src="`https://tmf-virtualrun.jp/images/oauth/${lang}/runkeeper-android-app-map.png`"
        width="270"
        alt=""
        class="img"
      />
      <p class="app-image__p">{{ Link.runkeeperMenu[lang] }}</p>
      <img
        :src="`https://tmf-virtualrun.jp/images/oauth/${lang}/runkeeper-android-app-menu.png`"
        width="270"
        alt=""
        class="img"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    Link: Object,
    lang: String,
  },
  name: "RunkeeperCapture",
};
</script>

<style scoped>
.app-os {
  margin: 45px 0 0 0;
  font-size: 28px;
  text-align: center;
}
.app-image {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  &__p {
    margin: 26px 0 0 0;
  }
  .img {
    margin: 13px 0 0 0;
    box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.16);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sp/oauth/RunkeeperCapture.vue